import { t } from '@/i18n/utils'

/**
 * 支付处理页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const payingCommonConfig = {
  texts: {
    get paymentFailure() { return t('PaymentFailure') },
    get paymentSuccess() { return t('PaymentSuccess') },
    get rechargePleaseWait() { return t('Rechargeait') },
  },
}
